const MANAGED = 'managed';
const CLICKABLE = 'clickable';
const OPACITY = 'opacity';
const FILTER = 'filter';
const LEGEND = 'legend';
const FEATURE_INFO = 'featureInfo';
const REMOVEABLE = 'removeable';
const SORTABLE = 'sortable';
const TREE = 'tree';

const createEmpty = (defaultValue) => {
    const value = defaultValue || false;
    
    return {
        [TREE]: value,
        [CLICKABLE]: value,
        [OPACITY]: value,
        [FILTER]: value,
        [LEGEND]: value,
        [FEATURE_INFO]: value,
        [REMOVEABLE]: value,
        [SORTABLE]: value
    }
}

export {
    MANAGED, CLICKABLE, OPACITY, FILTER, LEGEND, FEATURE_INFO, REMOVEABLE, SORTABLE, TREE, createEmpty
}